var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FieldsetStructure',{attrs:{"model":_vm.internalModel,"element":_vm.permissionFieldsetElement},on:{"update:model":function($event){_vm.internalModel=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }